import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    common: {
      notAvailableYet: 'This feature is not available yet',
      checkBackLater: 'Please check back later for updates',
      retry: 'Retry',
      noPermission: 'Access Denied',
      contactAdmin:
        'You do not have permission to access this page. Please contact your administrator for assistance.',
      goBack: 'Go Back'
    }
  },
  es: {
    common: {
      notAvailableYet: 'Este modulo aún no está disponible',
      checkBackLater: 'Por favor, vuelve más tarde para ver actualizaciones',
      retry: 'Reintentar',
      noPermission: 'Acceso Denegado',
      contactAdmin:
        'No tienes permiso para acceder a esta página. Por favor, contacta con tu administrador para obtener ayuda.',
      goBack: 'Volver'
    }
  }
}

export default createI18n({
  legacy: false,
  locale: 'es',
  fallbackLocale: 'es',
  messages
})
